<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-10 col-lg-8 col-xl-6 mx-auto pt-3">

        <div v-if="createMode">
          <h1 class="text-center pb-3">Create user</h1>
          <create-user-form @createSuccess="toggleMode"></create-user-form>
        </div>

        <div v-else class=" text-center">
          <h2>Success</h2>
          <button @click="toggleMode" class="btn btn-lg btn-success" type="button">Add user</button>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
import CreateUserForm from '../components/forms/CreateUserForm'

export default {
  components: {
    CreateUserForm,
  },
  data() {
    return {
      createMode: true,
    }
  },
  methods: {
    toggleMode() {
      this.createMode = !this.createMode
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/pages/CreateUserPage.vue